import './style/index.less';
import CheckItem from './CheckItem';

export default CheckItem;
